<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-10 18:51:23
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-17 15:51:44
 * @FilePath: \mrc-base-server-view\src\views\data-stored-procedure\index.vue
-->
<template>
  <div>
    <div v-if="$route.name == 'data-stored-procedure'">
      <mrc_ess_table
        :headers="headers"
        :hideAddBtn="!hasBtn('add-stored-procedure')"
        v-if="$route.name == 'data-stored-procedure'"
        pageName="data-stored-procedure-add"
        :paginationOptions="paginationOptions"
        @turnPage="getList"
        :isLoading="loading"
        :slotKey="['procedure_name', 'org_level_uuid']"
        :items="desserts"
      >
        <template v-slot:search>
          <v-row
            class="d-flex justify-end"
            style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px"
          >
            <mrc_ess_advanceFilterAndSearchInput
              class="mt-4"
              v-model="systemSeniorQueryString"
              @success="getList({ cpage: 1 })"
              :systemFieldMeta="systemFieldMeta"
            ></mrc_ess_advanceFilterAndSearchInput>
          </v-row>
        </template>
        <template v-slot:item.org_level_uuid="{ item }">
          {{ INT(item.org_level_uuid) }}
        </template>
        <template v-slot:item.procedure_name="{ item }">
          <div class="procedure_name">
            <span class="text-body-s">{{ INT(item.procedure_name) }}</span>
            <span class="text-caption text--secondary">{{
              INT(item.procedure_description)
            }}</span>
          </div>
        </template>

        <template v-slot:item.actions="{ item }">
          <menu-list
            :list="[
              {
                name: $t('label_View'),
                show: hasBtn('view-stored-procedure'),
                type: 'view',
              },
              {
                name: $t('label_Edit'),
                show:
                  hasBtn('edit-stored-procedure') &&
                  editPermission(item.org_level_uuid),
                type: 'edit',
              },
              {
                name: $t('label_delete'),
                show:
                  hasBtn('delete-stored-procedure') &&
                  editPermission(item.org_level_uuid),
                type: 'del',
              },
            ]"
            @handleClick="handleClick($event, item)"
          >
            <template v-slot:showAction>
              <v-icon
                v-btnAuth="[
                  'view-stored-procedure',
                  'edit-stored-procedure',
                  'delete-stored-procedure',
                ]"
                >mdi-dots-vertical</v-icon
              >
            </template>
          </menu-list>
        </template>
      </mrc_ess_table>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators"
import {
  getProcedureAll,
  delProcedure,
} from "@/service/api/dataStoredProcedure"
export default {
  components: {},
  props: {},
  data() {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      desserts: [],
      loading: false,
      paginationOptions: {
        pagesize: this.$store.state.pageSize,
        cpage: this.$store.state.cpage,
        totalcount: 0, //总条数
        totalpage: 0, //总页数
      },
    }
  },
  validations: {},
  computed: {
    list() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-stored-procedure"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-stored-procedure"),
          type: "edit",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-stored-procedure"),
          type: "del",
        },
      ]
    },
    headers() {
      return [
        {
          text: this.$t("label_Stored_procedure_name"),
          align: "start",
          sortable: false,
          value: "procedure_name",
        },
        {
          text: this.$t("label_The_company"),
          align: "start",
          sortable: false,
          value: "org_level_uuid",
        },
        {
          text: " ",
          align: "end",
          sortable: false,
          value: "actions",
          width: "20",
        },
      ]
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1)
  },
  async created() {
    await this.getBtnPermissionList()
  },
  watch: {
    async "$route.name"(val) {
      if (val == "data-stored-procedure") {
        await this.getList()
      }
    },
  },
  async mounted() {
    if (this.$route.name == "data-stored-procedure") {
      await this.getList()
    }
  },
  beforeDestroy() {},
  methods: {
    editPermission(uuid) {
      if (this.$store.state.userData.userType == 1) {
        if (uuid && uuid.length > 0) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    async getList(obj) {
      if (
        this.desserts.length == 1 &&
        this.paginationOptions.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.paginationOptions.cpage--
      if (obj) {
        this.paginationOptions = { ...this.paginationOptions, ...obj }
      }
      this.loading = true
      this.desserts = []
      const res = await getProcedureAll({
        cpage: this.paginationOptions.cpage,
        pagesize: this.paginationOptions.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
      if (res.code == 200) {
        this.desserts = res.data
        this.paginationOptions.totalcount = res.totalcount
        this.paginationOptions.totalpage = res.totalpage
        this.systemFieldMeta = res.systemFieldMeta
        this.field_alias_name = res.field_alias_name
        this.table_alias_name = res.table_alias_name
      }
      this.loading = false
    },
    handleClick({ item }, obj) {
      if (item.type == "view") {
        this.$store.commit("set_subPage_name", obj.procedure_name)
        this.$store.commit("set_uuid", obj.uuid)
        this.$store.commit("set_iconstatus", true) //行内进图标显示
        this.$router.push({
          name: "data-stored-procedure-detail",
          params: {
            name: obj.procedure_name,
            uuid: obj.uuid,
          },
        })
      }
      // 编辑
      if (item.type == "edit") {
        this.$store.commit("set_subPage_name", obj.procedure_name)
        this.$store.commit("set_uuid", obj.uuid)
        this.$store.commit("set_iconstatus", false)
        this.$router.push({
          name: "data-stored-procedure-detail",
          params: {
            name: obj.procedure_name,
            uuid: obj.uuid,
          },
        })
      }
      if (item.type == "del") {
        this.$myConfirm({ content: this.$t("message_Confirm_the_deletion") })
          .then(async () => {
            const del = await delProcedure({
              uuid: obj.uuid,
            })
            if (del.code == 200) {
              this.$Message({
                text: this.$t("message_The_deletion_was_successful"),
              })
              // this.desserts.length === 1  只有一条数据 删除就请求上一页的数据
              if (
                this.desserts.length === 1 &&
                this.paginationOptions.cpage > 1
              ) {
                this.paginationOptions.cpage--
              }
              await this.getList()
            }
          })
          .catch(() => {})
      }
    },
  },
}
</script>

<style scoped>
.procedure_name {
  display: flex;
  flex-direction: column;
}
</style>
